export const executeCallbackFunction = async (callbackFunction) => {
    if (!callbackFunction)
        return;
    try {
        await callbackFunction();
    }
    catch (error) {
        console.error(`[executeCallbackFunction] Callback execution failed: ${error}`);
    }
};
//# sourceMappingURL=callback.js.map